module.exports = __webpack_public_path__ + "static/media/ws.053a8486.svg";